import React, { Component } from 'react';
import { connect } from "react-redux";
import moment from "moment";

import './puffWidget.css';
import Light from '../../atoms/light/light';
import { playClicked } from '../../../redux/actions';

import Carousel from '../carousel/carousel';

class PuffWidget extends Component {
  constructor(props) { // active tab
    super(props);
    this.state = { active: 'puff' };
  }
  setActive = activePage => {
    this.setState({active: activePage})
  }
  render() {
    const { active } = this.state;
    const { user } = this.props;
    return(
      <div className='widget carousel small'>
        {this.renderCarousel(active) }
        <Carousel items={['puff', 'info']} active={active} onClick={this.setActive} />
      </div>
    )
  }
  renderCarousel(active) {
    const { companyInfo, isPuffing, user } = this.props;
    if(active === 'puff') {
      return (
        <div className='flex'>
          <div className='light'><Light color={isPuffing ? 'blue' : 'green'} blink={isPuffing ? 'true' : 'false'} /></div>
          {isPuffing ?
            <div className='details puff'>
              <p className="italic">Take a deep breath because <br/> a new puff is on it's way!</p>
            </div>
          : <div className='details puff'>
            <p className="italic">All the magic needed to provide you of healthy air is up and running!</p>
            {this.renderVideo()}
            </div>
          }
        </div>
      )
    } else {
      return (
        <div className='flex'>
          <div className='light'><Light color={isPuffing ? 'blue' : 'green'} blink={isPuffing ? 'true' : 'false'} /></div>
          <div className='details puff'>
            <p>We bring nature inside by adding positive organisms into the air ducts.</p>
          </div>

        </div>
      )
    }
  }
  renderVideo() {
    return (
      <div className='flex clickable' onClick={() => this.props.playClicked()}>
        <div className='mdi mdi-play-circle' />
        <p>  Push for more info</p>
      </div>
    )
  }
}

function mapStateToProps(state) {
  let currentCustomerId = state.general.company.customerId;
  let currentCustomer = currentCustomerId && state.firestore.data.customers[currentCustomerId];
  let currentCustomerPuffExpiry = currentCustomer.puffExpires;

  return {
    isPuffing: currentCustomerPuffExpiry && moment().isBefore(moment(currentCustomerPuffExpiry)),
    user: state.general.user
  }
}


export default connect(mapStateToProps, { playClicked })(PuffWidget);
